import React from "react"
import { Link } from "react-router-dom"
import Icon from "@mdi/react"
import { mdiHomeVariant } from "@mdi/js"

export function Navbar ({ onClick1, onClick2, text1, text2, second }) {

    // onClick1 -> function for first button
    // text1 -> text for first button
    // onClick2 -> function for second button
    // text2 -> text for second button
    // second -> if true, show ONLY THE SECOND!!! button

    return (

        <header className="header">

            <div className='left-container'>
                <div className="home-icon">
                    <Link to="/" className='home-logo-container'><Icon path={mdiHomeVariant} color="#2582da" style={{ width: "2.5rem", height: "2.5rem"}}/></Link>
                </div>
                <img src={'/images/mfaktor_logo.png'} alt='M-Faktor'/>
            </div>

            <div className='right-container'>
                {second && <button className='nav-right-action-button' onClick={onClick1}>{text1}</button>}
                <button className='nav-right-action-button' onClick={onClick2}>{text2}</button>
            </div>

        </header>

    )

}

